// extracted by mini-css-extract-plugin
export default {"NewsFilter":"NewsFilter_NewsFilter__lLl3o"};